import axios from "axios";
import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";

export const Carousel = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [slides, setSlides] = useState([]);
  const [isHovering, setIsHovering] = useState(false);
  const intervalRef = useRef(null);

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    startAutoSlide();

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [slides]);

  const startAutoSlide = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }

    intervalRef.current = setInterval(() => {
      if (!isHovering && slides.length > 2) {
        setActiveIndex((prevIndex) => (prevIndex + 1) % (slides.length - 2));
      }
    }, 5000);
  };

  const getData = () => {
    axios
      .get("/page-section/public/shows?sectionType=banner")
      .then((res) => {
        const slidesData = res.data.data;
        setSlides(slidesData);
      })
      .catch((err) => console.log(err));
  };

  const handleMouseEnter = () => {
    setIsHovering(true);
  };

  const handleMouseLeave = () => {
    setIsHovering(false);
  };

  const handleNext = () => {
    setActiveIndex((prevIndex) => (prevIndex + 1) % slides.length);
  };

  const handlePrev = () => {
    setActiveIndex(
      (prevIndex) => (prevIndex - 1 + slides.length) % slides.length,
    );
  };

  // const getSlideUrl = (slide) => {
  //   if (!slide?.content[0]?.url) return "#";
  //   return slide.content[0].url.startsWith("http")
  //     ? slide.content[0].url
  //     : `/${slide.content[0].url}`;
  // };

  return (
    <>
      <div className="container-fluid mb-3">
        <div className="row px-xl-5">
          <div className="col-lg-12">
            <div
              id="header-carousel"
              className="carousel slide carousel-fade mb-30 mb-lg-0"
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <div className="carousel-inner">
                {slides?.map((slide, index) => (
                  <div
                    key={index}
                    className={`carousel-item position-relative image-carousel ${
                      index === activeIndex ? "active" : ""
                    } `}
                  >
                    <Link to={slide.content[0]?.link || "#"}>
                      <img
                        className="position-absolute w-100 h-100"
                        src={slide?.content[0]?.imageUrl}
                        style={{ objectFit: "cover" }}
                        alt={slide?.content[0]?.title || "Slide image"}
                      />
                    </Link>
                    {slide.content[0]?.title &&
                      slide.content[0]?.description && (
                        <div className="carousel-caption d-flex flex-column align-items-center justify-content-center">
                          <div className="p-3" style={{ maxWidth: "700px" }}>
                            <h1 className="display-4 text-white mb-3">
                              <Link to={slide.content[0]?.link || "#"}>
                                {slide.content[0]?.title}
                              </Link>
                            </h1>
                            <p className="mx-md-5 px-5">
                              {slide.content[0]?.description}
                            </p>
                          </div>
                        </div>
                      )}
                  </div>
                ))}
              </div>

              {/* Carousel Controls */}
              <a
                className="carousel-control-prev"
                onClick={handlePrev}
                style={{ cursor: "pointer" }}
              >
                <div
                  className="carousel-control-prev-icon"
                  aria-hidden="true"
                ></div>
              </a>
              <a
                className="carousel-control-next"
                onClick={handleNext}
                style={{ cursor: "pointer" }}
              >
                <div
                  className="carousel-control-next-icon"
                  aria-hidden="true"
                ></div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
